const data = [
  {
    Name: "Pratham Yadav",
    Board: "Mentor",
    Position: "Mentor",
    Photo:
      "https://res.cloudinary.com/dptdrzycj/image/upload/v1704214739/Pratham_Yadav_R_23-24_-_Pratham_Yadav_nqb8zk.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/pratham007yadav/",
    GitHubProfile: "https://github.com/raptor-2001",
    InstagramProfile: "https://www.facebook.com/pratham.yadao",
  },
  {
    Name: "Sarthak Deshmukh",
    Board: "Mentor",
    Position: "Mentor",
    Photo:
      "https://res.cloudinary.com/dptdrzycj/image/upload/v1704214916/sd_-_Sarthak_Deshmukh_z3jmdj.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/sarthak-deshmukh-a3a956213/",
    GitHubProfile: "https://github.com/SarthakD15",
    InstagramProfile: "https://www.instagram.com/sarthakd1512/",
  },
  {
    Name: "Mandar kamble",
    Board: "Mentor",
    Position: "Mentor",
    Photo:
      "https://res.cloudinary.com/dptdrzycj/image/upload/v1704214261/Screenshot_20220817-093147_Gallery_-_2020BTEIT00004_KAMBLE_MANDAR_RAJPAL_b5dceq.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/mandar-kamble-096504246/",
    GitHubProfile: "https://github.com/Mandykamble",
    InstagramProfile: "https://www.instagram.com/mandyytory/",
  },
  {
    Name: "Om Gharge ",
    Board: "Mentor",
    Position: "Mentor",
    Photo:
      "https://res.cloudinary.com/dptdrzycj/image/upload/v1704214322/20230619_004138_-_Om_Gharge_c3x3jv.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/om-gharge",
    GitHubProfile: "https://github.com/ProProgrammer18",
    InstagramProfile: "https://www.instagram.com/_om_gharge_/",
  },
  {
    Name: "Sonali  Kaingade",
    Board: "Mentor",
    Position: "Mentor",
    Photo:
      "https://res.cloudinary.com/dptdrzycj/image/upload/v1704214498/IMG_20221107_113326_-_sonali_kaingade_lb4oig.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/sonali-kaingade-915483239",
    GitHubProfile: "https://github.com/Sonalikaingade",
    InstagramProfile:
      "https://instagram.com/_.sonali.kaingade._?utm_source=qr&igshid=MzNlNGNkZWQ4Mg%3D%3D",
  },
  {
    Name: "Vedant Joshi",
    Board: "Mentor",
    Position: "Mentor",
    Photo:
      "https://res.cloudinary.com/dptdrzycj/image/upload/v1704214555/myimage_-_2020BTEIT00045_JOSHI_VEDANT_ABHAY_d9uryl.png",
    LinkedInProfile: "https://www.linkedin.com/in/vedant-joshi-018353179/",
    GitHubProfile: "https://github.com/vedantjoshi-git",
    InstagramProfile: "https://www.instagram.com/vedantjoshi_12/",
  },
  {
    Name: "Abhishek Deokar",
    Board: "Mentor",
    Position: "Mentor",
    Photo:
      "https://res.cloudinary.com/dptdrzycj/image/upload/v1704214612/Abhishek_Deokar_-_Abhishek_Deokar_yh1sga.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/abhishek-deokar-006752206/",
    GitHubProfile: "https://github.com/Abhishek782",
    InstagramProfile: "https://www.instagram.com/abhishekdeokar782/",
  },
  {
    Name: "Harshal Gawande",
    Board: "Mentor",
    Position: "Mentor",
    Photo:
      "https://res.cloudinary.com/dptdrzycj/image/upload/v1704214653/IMG_20230730_203640_474_-_Harshal_Gawande_op0sfg.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/harshal-gawande-606500210",
    GitHubProfile: "https://github.com/Harshal152002",
    InstagramProfile:
      "https://instagram.com/harshal__15____?utm_source=qr&igshid=MzNlNGNkZWQ4Mg%3D%3D",
  },
  {
    Name: "Swapnil Kulkarni",
    Board: "Mentor",
    Position: "Mentor",
    Photo:
      "https://res.cloudinary.com/dptdrzycj/image/upload/v1704214694/20230829_114659_-_Swapnil_Kulkarni_xgxnu4.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/swapnil-kulkarni-2200991a5",
    GitHubProfile: "https://github.com/Swapnil-Kulkarni-2001",
    InstagramProfile:
      "https://instagram.com/swapnil_kulkarni_2001?utm_source=qr&igshid=MzNlNGNkZWQ4Mg%3D%3D",
  },
  {
    Name: "Mohit Khairnar",
    Board: "Mentor",
    Position: "Club Service Director",
    Photo:
      "https://res.cloudinary.com/dptdrzycj/image/upload/v1704214795/0_-_Mohit_Khairnar_xo19ls.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/mohit-khairnar-27159b232/",
    GitHubProfile: "https://github.com/mohitKhairnar",
    InstagramProfile: "",
  },
  {
    Name: "Ankur Singh",
    Board: "Mentor",
    Position: "Programming Expert",
    Photo:
      "https://res.cloudinary.com/dptdrzycj/image/upload/v1704214849/IMG_20230815_082650_-_Singh_Ankur_nsohan.jpg",
    LinkedInProfile:
      "https://www.linkedin.com/me?trk=p_mwlite_feed_updates-secondary_nav",
    GitHubProfile: "https://github.com/Sahil-2003",
    InstagramProfile: "https://www.instagram.com/ankur.singh.18_05/",
  },
  {
    Name: "Ayush Wadalkar",
    Board: "Mentor",
    Position: "Mentor ",
    Photo:
      "https://res.cloudinary.com/dptdrzycj/image/upload/v1704214977/IMG_20230830_195715_-_Ayush_Wadalkar_b24jga.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/ayush-wadalkar-7b8917219",
    GitHubProfile: "https://github.com/AyushWadalkar",
    InstagramProfile:
      "https://instagram.com/ayushwadalkar?utm_source=qr&igshid=ZDc4ODBmNjlmNQ%3D%3D",
  },
  {
    Name: "Adwait Samak",
    Board: "Mentor",
    Position: "Mentor",
    Photo:
      "https://res.cloudinary.com/dptdrzycj/image/upload/v1704215046/WhatsApp_Image_2023-08-30_at_20.04.09_-_Adwait_Samak_lxzokd.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/adwait-samak-10a096212/",
    GitHubProfile: "https://github.com/AdwaitSamak",
    InstagramProfile:
      "https://instagram.com/adwait.samak?utm_source=qr&igshid=MzNlNGNkZWQ4Mg%3D%3D",
  },
  {
    Name: "Dipankar Dubey",
    Board: "Mentor",
    Position: "Mentor",
    Photo:
      "https://res.cloudinary.com/dptdrzycj/image/upload/v1704215125/dipankar_photo_-_2020BTEIT00057_DUBEY_DIPANKAR_SANTOSH_te0jji.jpg",
    LinkedInProfile: "http://www.linkedin.com/in/dipankar-dubey-4aa394207",
    GitHubProfile: "https://github.com/Dipankar2003/",
    InstagramProfile: "https://www.instagram.com/dipankar__dubey/",
  },
  {
    Name: "Shraddha Kore",
    Board: "Mentor",
    Position: "Mentor",
    Photo:
      "https://res.cloudinary.com/dptdrzycj/image/upload/v1704215168/WhatsApp_Image_2023-08-30_at_11.32.53_PM_-_Shraddha_Kore_q2hjhk.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/shradha-kore-b7362a1a0/",
    GitHubProfile: "https://github.com/shraddhakore",
    InstagramProfile: "https://www.instagram.com/shradha_kore/",
  },
  {
    Name: "Shikha Choudhari",
    Board: "Mentor",
    Position: "Mentor",
    Photo:
      "https://res.cloudinary.com/dptdrzycj/image/upload/v1704215199/IMG_20211225_183204_-_Shikha_Choudhari_pvxom9.jpg",
    LinkedInProfile: "www.linkedin.com/in/shikhachoudhari",
    GitHubProfile: "http://www.github.com/shikhachoudhari",
    InstagramProfile:
      "https://instagram.com/_shikha_8111?utm_source=qr&igshid=ZDc4ODBmNjlmNQ%3D%3D",
  },
];
export default data;
